"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Heart: function() {
        return Heart;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Heart = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9929 3.71703C9.65298 1.67214 6.19252 1.25369 3.50521 3.54978C0.598423 6.0334 0.176093 10.2162 2.47471 13.1741C3.38466 14.345 5.20086 16.1326 6.90716 17.7358C8.63382 19.3582 10.3164 20.8548 11.006 21.4635C11.5717 21.9628 12.4149 21.9628 12.9805 21.4635C13.6701 20.8548 15.3527 19.3582 17.0794 17.7358C18.7857 16.1326 20.6019 14.345 21.5118 13.1741C23.8016 10.2276 23.4445 6.0125 20.4709 3.54101C17.7537 1.28258 14.3301 1.67136 11.9929 3.71703ZM11.2333 5.78587C9.52828 3.7925 6.818 3.34987 4.80441 5.07033C2.7011 6.86745 2.41807 9.84183 4.05392 11.9468C4.8521 12.9739 6.55138 14.6572 8.27666 16.2783C9.74634 17.6592 11.1864 18.9503 11.9933 19.6664C12.8001 18.9503 14.2402 17.6592 15.7099 16.2783C17.4352 14.6572 19.1344 12.9739 19.9326 11.9468C21.5773 9.83046 21.3152 6.84332 19.1925 5.0791C17.1256 3.36117 14.4507 3.80131 12.7532 5.78587C12.5632 6.00798 12.2856 6.13586 11.9933 6.13586C11.701 6.13586 11.4233 6.00798 11.2333 5.78587Z",
        fill: "currentColor"
    })
}), "Heart");
const _default = Heart;
